import { useMemo } from 'react';
import { InfoBanner } from '@ui';
import { useCaseDetailsWithReviews } from '@lp/features/RoutePlanner/hooks/useCaseDetailsWithReviews';
import { isPrimaryLocation } from '@lp/features/RoutePlanner/utils/case-locations';
import { BaseGroundLegSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useWatchFields } from '@/hooks/useWatchFields';
import { CaseResourceType } from '@/api/apis/case';
import { LegLocationTypeEnum } from '@/api/apis/route';

export const LightsAndSirensBanner = () => {
  const { isLightsSirensRequired, txCenterDetails } = useCaseDetailsWithReviews();
  const { arrivalLocation, resources, hasSCS } = useWatchFields<BaseGroundLegSchemaValues>([
    'arrivalLocation',
    'resources',
    'hasSCS',
  ] as const);

  const hasOrganResource = useMemo(
    () => !!resources.find((r) => r.resourceType === CaseResourceType.OCSConsole) || hasSCS,
    [resources, hasSCS],
  );
  const isTxCenterArrival = isPrimaryLocation(
    { locationType: arrivalLocation.locationType, locationId: arrivalLocation.id },
    LegLocationTypeEnum.txcenter,
    txCenterDetails?.id,
  );
  const showLightsSirensBanner = isLightsSirensRequired && hasOrganResource && isTxCenterArrival;

  if (!showLightsSirensBanner) return null;

  return <InfoBanner iconType="lightSirens">Lights and sirens were requested for this leg</InfoBanner>;
};
